import React from 'react';

import { InnerHtmlProps } from '@/widgets/InnerHtml/models';

import classes from './index.module.css';

const InnerHtml = ({ content, className }: InnerHtmlProps) => {
    return <div className={`${className} ${classes.htmlContainer}`} dangerouslySetInnerHTML={{ __html: content }} />;
};

export default InnerHtml;
